import { type ILaborDistribution } from '@/interfaces'

export const sampleLaborDistribution: ILaborDistribution = {
	weeksOffsetFromShip: [-15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6],
	durationInWeeks: {
		'1': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 93.44, 2.43, 1.36, 0.99, 0.76,
			0.61, 0.42
		],
		'2': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 49.62, 43.82, 2.43, 1.36, 0.99, 0.76,
			0.61, 0.42
		],
		'3': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 35.24, 32.0, 26.19, 2.43, 1.36, 0.99, 0.76,
			0.61, 0.42
		],
		'4': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 23.55, 27.4, 24.15, 18.35, 2.43, 1.36, 0.99,
			0.76, 0.61, 0.42
		],
		'5': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 15.31, 19.72, 23.57, 20.32, 14.52, 2.43, 1.36, 0.99,
			0.76, 0.61, 0.42
		],
		'6': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 9.79, 13.36, 17.76, 21.61, 18.36, 12.56, 2.43, 1.36, 0.99,
			0.76, 0.61, 0.42
		],
		'7': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 6.43, 8.72, 12.28, 16.69, 20.54, 17.29, 11.49, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'8': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 4.18, 5.83, 8.12, 11.69, 16.09, 19.94, 16.7, 10.89, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'9': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 3.18, 3.79, 5.43, 7.72, 11.29, 15.69, 19.54, 16.3, 10.49, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'10': [
			0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.22, 2.93, 3.54, 5.18, 7.48, 11.04, 15.45, 19.3, 16.05, 10.25, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'11': [
			0.0, 0.0, 0.0, 0.0, 0.0, 1.72, 2.04, 2.76, 3.37, 5.01, 7.3, 10.87, 15.28, 19.13, 15.88, 10.08, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'12': [
			0.0, 0.0, 0.0, 0.0, 1.53, 1.58, 1.91, 2.62, 3.23, 4.87, 7.17, 10.73, 15.14, 18.99, 15.74, 9.94, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'13': [
			0.0, 0.0, 0.0, 1.25, 1.42, 1.48, 1.8, 2.52, 3.12, 4.77, 7.06, 10.63, 15.03, 18.88, 15.64, 9.83, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'14': [
			0.0, 0.0, 0.94, 1.17, 1.35, 1.41, 1.73, 2.45, 3.05, 4.7, 6.99, 10.56, 14.96, 18.81, 15.56, 9.76, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'15': [
			0.0, 0.78, 0.88, 1.12, 1.29, 1.35, 1.67, 2.39, 3.0, 4.64, 6.93, 10.5, 14.9, 18.75, 15.51, 9.7, 2.43, 1.36,
			0.99, 0.76, 0.61, 0.42
		],
		'16': [
			0.67, 0.74, 0.84, 1.07, 1.25, 1.31, 1.63, 2.35, 2.95, 4.6, 6.89, 10.46, 14.86, 18.71, 15.46, 9.66, 2.43,
			1.36, 0.99, 0.76, 0.61, 0.42
		]
	}
}
